import { CheckCircle, UserPlus } from "@phosphor-icons/react";
import { useCallback, useState } from "react";

type FriendListItemProps = {
  friend: any;
  onClick: () => void;
};

export default function FriendListItem({
  friend,
  onClick,
}: FriendListItemProps) {
  const [clicked, setClicked] = useState(false);

  const handleClick = useCallback(() => {
    if (clicked) {
      return;
    }
    setClicked(!clicked);
    onClick();
  }, [clicked, onClick]);

  return (
    <div
      className="w-full flex items-center justify-between px-2 pr-3 py-2 bg-white rounded-lg shadow  cursor-pointer hover:ring-1"
      onClick={() => handleClick()}
    >
      <div className="flex-1 flex items-center gap-2">
        <div className="w-10 h-10">
          {friend.image ? (
            <img
              src={friend.image.small.url}
              alt=""
              className="w-10 h-10 rounded-full"
            />
          ) : null}
        </div>
        <div className="flex-1 flex md:flex-col">
          <p className="text-sm flex-1">{friend.name}</p>
          <div className="text-brand-red">
            {clicked ? (
              <div className="flex items-center text-brand-dark-green gap-1 text-xs">
                <CheckCircle className="h-5 w-5 text-brand-dark-green animate-pulse" />
                <span>invitado</span>
              </div>
            ) : (
              <div className="flex items-center text-brand-red gap-1 text-xs">
                <UserPlus className="h-5 w-5" />
                <span>invitar amigo</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
